import React from "react";
import { Col } from "reactstrap";
import DashPanel from "../common/DashPanel";
import SectionTitle from "../common/SectionTitle";
import ChipRow from "../common/ChipRow";
import StockRow from "../common/StockRow";
import { fmtNum } from "../../utils/formatters";
import { T } from "../../constants/theme";
import { productionData } from "../../data/dashboardMockData";

const StockStatusSection = ({ loading }) => (
  <Col xl={6} className="d-flex">
    <DashPanel title="Stock Status" icon="bx bx-package" iconColor={T.purple} loading={loading}>
      {productionData.stock.map((s, i) => (
        <StockRow key={i} item={s} loading={loading} />
      ))}

      <SectionTitle style={{ marginTop: "14px" }}>Material Issues</SectionTitle>
      <ChipRow
        items={[
          {
            label: "Issued",
            value: productionData.materialIssueInsights.totalIssued,
            color: T.blue,
          },
          {
            label: "Pending",
            value: productionData.materialIssueInsights.pendingApproval,
            color: T.yellow,
          },
          {
            label: "Approved",
            value: productionData.materialIssueInsights.approved,
            color: T.green,
          },
        ]}
      />
      <div className="sad-scroll-list sad-scroll-list--sm">
        {productionData.materialIssueInsights.topIssuedMaterials.map((m, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "4px 0",
              borderBottom: "1px solid #f1f3f5",
              fontSize: "12px",
            }}
          >
            <span style={{ color: T.text }}>{m.material}</span>
            <span style={{ fontWeight: 700, color: T.blue }}>
              {fmtNum(m.qty)} {m.unit}
            </span>
          </div>
        ))}
      </div>
    </DashPanel>
  </Col>
);

export default StockStatusSection;
